const PADDING_FROM_TOP_PAGE_TO_TABLE = 204;

export { PADDING_FROM_TOP_PAGE_TO_TABLE };
